import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '../base';
import CloudinaryPicture from './cloudinaryPicture';
import PrismicHtmlContent from './prismicHtmlContent';

const BioSlice = props => {
  return (
    <Grid.Row className="mt-3">
      <Grid.Col xs={3}>
        <CloudinaryPicture imageKey={props.slice.primary.image_key} className="mw-100" />
      </Grid.Col>
      <Grid.Col xs={9}>
        <PrismicHtmlContent content={props.slice.primary.bio} />
      </Grid.Col>
    </Grid.Row>
  );
};

BioSlice.propTypes = {
  slice: PropTypes.object,
};

const PrismicSlices = props => {
  if (!props.slices || props.slices.length === 0) {
    return null;
  }

  return (
    <>
      {props.slices.map(slice => {
        if (slice.slice_type === 'bio') {
          return <BioSlice slice={slice} />;
        }

        throw new Error('Unknown slice');
      })}
    </>
  );
};

PrismicSlices.propTypes = {
  slices: PropTypes.array,
};

export default PrismicSlices;
